import React, { useState, useEffect } from "react";
import { db } from "./firebaseConfig";
import TableRow from "./component/TableRow";
import { Link } from "react-router-dom";

function Table({ allMembers }) {
  return (
    <div className="userList">
      <div className="userList__overlay  p-md-5 p-2 text-center">
        <div className="intro my-3">
          <h3 className="text-danger">
            Shimabari Students' Association For Welfare(SSAW)
          </h3>
          <h5>Shimabari, Sherpur, Bogura</h5>
        </div>
        <h3 className="text-info"> All Members </h3>
        <div className="row__table">
          <table className="table table-striped table-dark mb-3">
            <thead>
              <tr>
                <th scope="col">No.</th>
                <th scope="col">Name</th>
                <th scope="col">Mobile</th>
                <th scope="col">Blood Group</th>
                <th scope="col">Institution</th>
                <th scope="col">Department</th>
                <th scope="col">Village</th>
                <th scope="col">HSC YEAR</th>
              </tr>
            </thead>
            <tbody>
              {allMembers.map((member, index) => (
                <TableRow key={index} index={index} member={member} />
              ))}
            </tbody>
          </table>
        </div>

        <Link to="/signup" className="btn-lg btn-primary m5-3">
          BECOME A MEMBER
        </Link>
      </div>
    </div>
  );
}

export default Table;
